import { render } from "./baseTextarea.vue?vue&type=template&id=4795bade"
import script from "./baseTextarea.vue?vue&type=script&lang=js"
export * from "./baseTextarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__